import React from 'react';
import NoResultsPreventivatore from '../preventivatore/NoResultsPreventivatore';

const ResultsQuotationNoResults = ({ resultsNumber }) => {
  return <NoResultsPreventivatore selectedProduct={''} resultsNumber={resultsNumber} />;
};

export default ResultsQuotationNoResults;
